import React from "react";
import css from "./DefiningSection.module.css";
import {TextView,FileView,SectionView} from "Components";


export default function DefiningSection(props){
    const {}=props;
    return (
        <div className={css.definingsection}>
            <SectionView 
                title="defining a component" 
                text={statics.description} 
            />
            <FileView className={css.codeview} code={statics.code}/>
            <TextView text={`
                As you noticed, we're setting the html content of a component using the 
                <a href="#vritra#View">View</a> 's special innateHTML setter
                instead of a simple innerHTML as it's a safer version of the latter .
            `}/>
        </div>
    )
}

const statics={
    description:`
        Defining components is going to be made the old fashion way, we mark the content
        and then add interaction by sprinkling on some JavaScript. The differentiating 
        factor is that the content and JavaScript are consolidated within a single location, 
        creating a cohesive and reusable block of code known as a component.
        @Here's what that looks like :
    `,
    code:'<div><span style="color: #c586c0;">import</span> {<span style="color: #9cdcfe;">View</span>} <span style="color: #c586c0;">from</span> <span style="color: #ce9178;">"vritra"</span>;</div><br><br><div><span style="color: #c586c0;">export</span> <span style="color: #c586c0;">default</span> <span style="color: #569cd6;">function</span> <span style="color: #dcdcaa;">Component</span>(<span style="color: #9cdcfe;">props</span>){</div><div>&nbsp; &nbsp; <span style="color: #569cd6;">const</span> <span style="color: #4fc1ff;">component</span><span style="color: #d4d4d4;">=</span><span style="color: #dcdcaa;">View</span>(<span style="color: #9cdcfe;">props</span>);</div><br><div>&nbsp; &nbsp; <span style="color: #4fc1ff;">component</span>.<span style="color: #9cdcfe;">innateHTML</span><span style="color: #d4d4d4;">=</span><span style="color: #ce9178;">`</span></div><div><span style="color: #ce9178;">&nbsp; &nbsp; &nbsp; &nbsp; &lt;!-- Component HTML content goes here --&gt;</span></div><div><span style="color: #ce9178;">&nbsp; &nbsp; `</span>;</div><br><div>&nbsp; &nbsp; <span style="color: #6a9955;">/* Javascript goes here */</span></div><br><div>&nbsp; &nbsp; <span style="color: #c586c0;">return</span> <span style="color: #4fc1ff;">component</span>;</div><div>}</div>',
}
